import { render, staticRenderFns } from "./ModalOsAVencerArmazem.vue?vue&type=template&id=e9b9cdbc&scoped=true&"
import script from "./ModalOsAVencerArmazem.vue?vue&type=script&lang=js&"
export * from "./ModalOsAVencerArmazem.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsAVencerArmazem.vue?vue&type=style&index=0&id=e9b9cdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b9cdbc",
  null
  
)

export default component.exports